import React, { Component } from 'react';
import axios from 'axios';
import moment from 'moment';
import { Switch, Route, withRouter } from 'react-router-dom';
import 'moment/locale/pt';
import InsightcareFooter from './components/InsightcareFooter';
import AuxRoutines from './AuxRoutines';
import { BACKEND_URL } from './config/constants';
//require('moment/locale/pt-BR');

class PainelAltaTransferencia extends Component {

  constructor(props) {
    super(props);
    const { match: { params } } = this.props;
    console.log(params);
    this.state={
      cycle:0,
      totalCycles:0,
      pacientes: [],
      numberOfElements: 0,
      base: params.base,
      company: params.company,
      locationName: AuxRoutines.getLocationName(params.base,params.company)
    };
    this.loadRequiredData = this.loadRequiredData.bind(this)
    setInterval(this.loadRequiredData, 20000);
		//setInterval(this.loadRequiredData, 5000);
    //this.randomize();
  }

  componentDidMount() {

    //Carrega o local se existe
    this.loadRequiredData().then(() => {
      this.setState({appIsReady: true});
    });
  }


  async loadRequiredData() {
    let sliceSize=9;

    moment.locale('pt');
    if (this.state.cycle===this.state.totalCycles) {
      let currentDateHour = moment().format('HH:mm | D [de] MMMM [de] YYYY');
      let pacientes = await this.requestData();
      let numberOfElements = pacientes.length;
      let cycle=1;
      let totalCycles=Math.ceil(numberOfElements/sliceSize);
      if (totalCycles==0) {
        cycle=0;
      }
      this.setState(
        {
          currentDateHour: currentDateHour,
          dashboardData: pacientes,
          pacientes: pacientes.slice(0, sliceSize),
          numberOfElements: numberOfElements,
          cycle: cycle,
          totalCycles: totalCycles
        }
      );
    }else {
      if (this.state.totalCycles>0) {
        this.setState({cycle: this.state.cycle+1,pacientes: this.state.dashboardData.slice(0+(sliceSize*this.state.cycle), sliceSize+(sliceSize*this.state.cycle))})
      }
    }

  }

	async requestData() {
    let returnData=this.state.pacientes; //In case request fails
    let url = BACKEND_URL + '/command-center/painel-alta-transferencia?base='+this.state.base;
    if (this.state.company!==undefined && this.state.company!==null) {
      url=url+'&company='+this.state.company;
    }
	  let response = await axios.get(url);
    
		//console.log(response.data);
    if (response.data && response.data.Status===true) {
      returnData=response.data.ResponseData;
    }
    return returnData;
  }
  
  render() {
    return (
      <div className="App">
        <header>
             <h1 id="title">Monitoramento Altas - {this.state.numberOfElements} pacientes ({this.state.cycle}/{this.state.totalCycles})</h1>
             <img src="/img/logo.png" alt="InsightCare"/>
         </header>

         <main className="content" id="panel1">
             <table className="table table-striped">
               <thead>
                 <tr>
                     <th width="1%"></th>
                     <th width="10%">
                         <img src="/img/icon_status.svg" alt=""/>Status
                     </th>
                     
                     <th width="25%">
                         <img src="/img/icon_patient.svg" alt=""/>Paciente
                     </th>
                     <th width="25%">
                         <img src="/img/icon_patient.svg" alt=""/>Leito Anterior
                     </th>
                     <th width="24%">
                         <img src="/img/icon_patient.svg" alt=""/>Leito
                     </th>
                     <th width="15%">
                         <img src="/img/icon_status.svg" alt=""/>Tempo
                     </th>
                 </tr>
               </thead>
               <tbody>
                {this.state.pacientes.map((data) => {
                    let status="-";
                    let color='';
                    let statusClass="ready";
                    let tdClassRx="";
                    let spanClassRx="";
                    let tdClassFarm="";
                    let spanClassFarm="";
                    let name = data.NOMEPACIENTE.split(' ').slice(-1).join(' ') + ', ' + data.NOMEPACIENTE.split(' ')[0].slice(0,1);
                    //let solicitante = data.NOMEPRESTADOR.split(' ')[0] + ' ' + data.NOMEPRESTADOR.split(' ').slice(-1).join(' ');
                    /*
                    if (data.TIPOATENDIMENTO==='U') {
                      color='red';
                    }
                    if (data.COLETAREALIZADA) {
                      status="Aguardando laudo";
                      tdClassRx="attention";
                      spanClassRx="success-circle";
                      statusClass="ready";
                    }else {
                      status="Aguardando coleta";
                      statusClass="waiting";
                      //tdClassRx="attention";
                      //spanClassRx="attention-circle";
                    }
                    */
                   status="Transferência";
                   if (data.ALTA) {
                     status='Alta Hospitalar';
                     statusClass="waiting";
                   }else {
                     if (data.ALTAMEDICA) {
                       status='Alta Médica';
                       statusClass="waiting";
                     }

                   }

                    if (data.MINUTOS<30) {
                      color='red';
                      tdClassFarm="attention";
                      spanClassFarm="attention-circle";
                    }else {
                      spanClassFarm="success-circle";
                    }

                    let time=data.MINUTOS;
                    if (data.MINUTOS>60) {
                      var hours = (data.MINUTOS/60);
                      var rhours = Math.floor(hours);
                      var minutes = (hours - rhours) * 60;
                      var rminutes = Math.round(minutes);
                      time=rhours + " hs " + rminutes + " mins";
                    }else {
                      time=time+' mins';
                    }

                    return (
                      <tr key={this.state.Paciente} className={statusClass}>
                          <td><div className="alert-label"></div></td>
                          <td style={{overflow:'hidden', whiteSpace: 'nowrap'}} align="left">{status}</td>
                          <td style={{overflow:'hidden', whiteSpace: 'nowrap',color:color}} align="left"><b>{name}</b>  ({data.CODIGOATENDIMENTO})</td>
                          <td style={{color:color}} align="left"><b>{data.LEITOANTERIOR}</b></td>
                          <td style={{color:color}} align="left"><b>{data.LEITO}</b></td>
                          <td className={tdClassFarm} align="left"><span className={spanClassFarm}></span>{time}</td>
                      </tr>
                    )
                  })
                }

               </tbody>
             </table>
         </main>


         <InsightcareFooter dateHour={this.state.currentDateHour} hospitalName={this.state.locationName}/>
      </div>
    );
  }
}

export default PainelAltaTransferencia;
